<template>
<div id="subscription-search">
  <search-form
    legend="Subscriptions"
    :pageRef="$parent"
    :searchUrl="searchUrl"
  />
</div>

</template>
<script>
import SearchForm from '@/components/PagedSearchFieldForm'

export default {
  computed: {
    searchUrl () {
      return this.apiUrl('/subscriptions/search', true)
    }
  },

  components: {
    'search-form': SearchForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SubscriptionSearch.vue